<h2 mat-dialog-title>Confirmation</h2>
<mat-dialog-content>This will start the Website Onboarding and you will be moved to Home Page. Are you sure to continue with the Onboarding?</mat-dialog-content>
<mat-dialog-actions style="justify-content: end;">
  <button  mat-button mat-dialog-close>Cancel</button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-button [mat-dialog-close]="true">Start Tour</button>
</mat-dialog-actions>